export default __webpack_public_path__ + "static/media/MayurDP.47933df7.jpeg";